export const box_shadow = ['rgba(149, 157, 165, 0.2) 0px 8px 24px',
    'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
    'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px',
    'rgba(0, 0, 0, 0.35) 0px 5px 15px',
    'rgba(0, 0, 0, 0.16) 0px 1px 4px',
    'rgba(0, 0, 0, 0.24) 0px 3px 8px',
    'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px',
    'rgba(0, 0, 0, 0.1) 0px 4px 12px',
    'rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px',
    'rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px',
    'rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
    'rgba(17, 12, 46, 0.15) 0px 48px 100px 0px',
    'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset',
    'rgba(255, 255, 255, 0.1) 0px 1px 1px 0px inset, rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px',
    'rgba(50, 50, 93, 0.25) 0px 50px 100px -30px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;',
    'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px',
    'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px',
    'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px',
    'rgb(38, 57, 77) 0px 20px 30px -10px',
    'rgba(6, 24, 44, 0.4) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 4px 6px -1px, rgba(255, 255, 255, 0.08) 0px 1px 0px inset',
    'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
    'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px',
    'rgba(50, 50, 93, 0.25) 0px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px',
    'rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset',
    'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px',
    'rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px',
    'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px',
    'rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px',
    'rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px',
    'rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px',
    'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
    'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px',
    'rgba(0, 0, 0, 0.05) 0px 0px 0px 1px',
    'rgba(0, 0, 0, 0.05) 0px 1px 2px 0px',
    'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px',
    'rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px',
    'rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    'rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px',
    'rgba(0, 0, 0, 0.25) 0px 25px 50px -12px',
    'rgba(0, 0, 0, 0.06) 0px 2px 4px 0px inset',
    'rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px',
    'rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px',
    'rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px',
    'rgba(0, 0, 0, 0.2) 0px 18px 50px -10px',
    'rgba(0, 0, 0, 0.1) 0px 10px 50px',
    'rgba(0, 0, 0, 0.04) 0px 3px 5px',
    'rgba(240, 46, 170, 0.4) -5px 5px, rgba(240, 46, 170, 0.3) -10px 10px, rgba(240, 46, 170, 0.2) -15px 15px, rgba(240, 46, 170, 0.1) -20px 20px, rgba(240, 46, 170, 0.05) -25px 25px',
    'rgba(240, 46, 170, 0.4) 0px 5px, rgba(240, 46, 170, 0.3) 0px 10px, rgba(240, 46, 170, 0.2) 0px 15px, rgba(240, 46, 170, 0.1) 0px 20px, rgba(240, 46, 170, 0.05) 0px 25px',
    'rgba(240, 46, 170, 0.4) 5px 5px, rgba(240, 46, 170, 0.3) 10px 10px, rgba(240, 46, 170, 0.2) 15px 15px, rgba(240, 46, 170, 0.1) 20px 20px, rgba(240, 46, 170, 0.05) 25px 25px',
    'rgba(245, 46, 170, 0.4) -5px 5px, #03A9F4 -10px 10px, #4FC3F7 -15px 15px, #81D4FA -20px 20px, #E1F5FE -25px 25px',
    'rgba(0, 0, 0, 0.07) 0px 1px 1px, rgba(0, 0, 0, 0.07) 0px 2px 2px, rgba(0, 0, 0, 0.07) 0px 4px 4px, rgba(0, 0, 0, 0.07) 0px 8px 8px, rgba(0, 0, 0, 0.07) 0px 16px 16px',
    'rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em',
    'rgba(0, 0, 0, 0.1) 0px 1px 2px 0px',
    'rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset',
    'rgba(3, 102, 214, 0.3) 0px 0px 0px 3px',
    'rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px',
    'rgba(0, 0, 0, 0.2) 0px 12px 28px 0px, rgba(0, 0, 0, 0.1) 0px 2px 4px 0px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset',
    'rgba(0, 0, 0, 0.15) 0px 5px 15px 0px',
    'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px',
    'blue 0px 0px 0px 2px inset, rgb(255, 255, 255) 10px -10px 0px -3px, rgb(31, 193, 27) 10px -10px, rgb(255, 255, 255) 20px -20px 0px -3px, rgb(255, 217, 19) 20px -20px, rgb(255, 255, 255) 30px -30px 0px -3px, rgb(255, 156, 85) 30px -30px, rgb(255, 255, 255) 40px -40px 0px -3px, rgb(255, 85, 85) 40px -40px',
    'rgb(85, 91, 255) 0px 0px 0px 3px, rgb(31, 193, 27) 0px 0px 0px 6px, rgb(255, 217, 19) 0px 0px 0px 9px, rgb(255, 156, 85) 0px 0px 0px 12px, rgb(255, 85, 85) 0px 0px 0px 15px',
    'rgb(204, 219, 232) 3px 3px 6px 0px inset, rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset',
    'rgba(136, 165, 191, 0.48) 6px 2px 16px 0px, rgba(255, 255, 255, 0.8) -6px -2px 16px 0px',
    'rgba(17, 17, 26, 0.1) 0px 1px 0px',
    'rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px',
    'rgba(17, 17, 26, 0.1) 0px 0px 16px',
    'rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px',
    'rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px',
    'rgba(17, 17, 26, 0.1) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 48px',
    'rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px',
    'rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px',
    'rgba(50, 50, 105, 0.15) 0px 2px 5px 0px, rgba(0, 0, 0, 0.05) 0px 1px 1px 0px',
    'rgba(0, 0, 0, 0.15) 0px 15px 25px, rgba(0, 0, 0, 0.05) 0px 5px 10px',
    'rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px',
    'rgba(0, 0, 0, 0.15) 0px 3px 3px 0px',
    'rgba(0, 0, 0, 0.08) 0px 4px 12px',
    'rgba(0, 0, 0, 0.15) 0px 2px 8px',
    'rgba(0, 0, 0, 0.18) 0px 2px 4px',
    'rgba(0, 0, 0, 0.1) -4px 9px 25px -6px',
    'rgba(0, 0, 0, 0.2) 0px 60px 40px -7px',
    'rgba(0, 0, 0, 0.4) 0px 30px 90px',
    'rgba(0, 0, 0, 0.56) 0px 22px 70px 4px',
    'rgba(0, 0, 0, 0.2) 0px 20px 30px',
    'rgba(255, 255, 255, 0.2) 0px 0px 0px 1px inset, rgba(0, 0, 0, 0.9) 0px 0px 0px 1px',
    'rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset',
    'rgba(0, 0, 0, 0.09) 0px 3px 12px',
    'rgba(0, 0, 0, 0.17) 0px -23px 25px 0px inset, rgba(0, 0, 0, 0.15) 0px -36px 30px 0px inset, rgba(0, 0, 0, 0.1) 0px -79px 40px 0px inset, rgba(0, 0, 0, 0.06) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px',
    'rgba(0, 0, 0, 0.45) 0px 25px 20px -20px',
    'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset',
    'rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgb(209, 213, 219) 0px 0px 0px 1px inset',
    'rgba(0, 0, 0, 0.35) 0px -50px 36px -28px inset',
    'rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 1px 1px',
    'rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px',
]

export const all_color_shades = [
    "#FF0000", "#FFC0CB", "#DC143C", "#8B0000", "#FF6347", "#FF4500", "#B22222", "#CD5C5C", "#7C0A02", "#C21807", "#E0115F", "#800000", "#B22222",
    "#A45A52", "#FFC0CB", "#FF69B4", "#FF1493", "#C71585", "#DB7093", "#FFB6C1", "#FFA07A", "#FF7F50", "#FF6347", "#FF4500", "#EE82EE", "#DA70D6",
    "#BA55D3", "#9932CC", "#4B0082", "#7B68EE", "#663399", "#8B008B", "#9400D3", "#9932CC", "#A020F0", "#D8BFD8", "#800080", "#BA55D3", "#9370DB",
    "#8A2BE2", "#6A5ACD", "#483D8B", "#4B0082", "#483D8B", "#3D2B1F", "#3E2F5B", "#4C516D", "#5D3FD3", "#5E5A80", "#6574CD", "#6A5ACD", "#6B6B83",
    "#6F00FF", "#7B68EE", "#7D26CD", "#8A2BE2", "#9400D3", "#0000FF", "#ADD8E6", "#87CEFA", "#1E90FF", "#6495ED", "#4169E1", "#00008B", "#0000CD",
    "#191970", "#00BFFF", "#00CED1", "#48D1CC", "#AFEEEE", "#87CEEB", "#4682B4", "#ADD8E6", "#87CEFA", "#1E90FF", "#6495ED", "#B0C4DE", "#CAE1FF",
    "#F0F8FF", "#F0FFFF", "#E6E6FA", "#D3D3D3", "#778899", "#708090", "#C6E2FF", "#BFEFFF", "#A4D3EE", "#00FFFF", "#E0FFFF", "#AFEEEE", "#7FFFD4",
    "#40E0D0", "#48D1CC", "#00CED1", "#20B2AA", "#5F9EA0", "#008B8B", "#008080", "#00FFFF", "#00C5CD", "#00BFFF", "#1E90FF", "#008080", "#008B8B",
    "#00CED1", "#00FFFF", "#00C5CD", "#00E5EE", "#00F5FF", "#40E0D0", "#48D1CC", "#7FFFD4", "#AFEEEE", "#BBFFFF", "#E0FFFF", "#E6FFFF", "#F0FFFF",
    "#008000", "#00FF00", "#7FFF00", "#ADFF2F", "#9ACD32", "#32CD32", "#228B22", "#006400", "#556B2F", "#8FBC8F", "#2E8B57", "#3CB371", "#20B2AA",
    "#66CDAA", "#7FFFD4", "#00FF00", "#7CFC00", "#7FFF00", "#ADFF2F", "#32CD32", "#00FA9A", "#00FF7F", "#90EE90", "#98FB98", "#9ACD32", "#8FBC8F",
    "#3CB371", "#2E8B57", "#20B2AA", "#66CDAA", "#00FF00", "#32CD32", "#7FFF00", "#ADFF2F", "#00FA9A", "#98FB98", "#90EE90", "#8FBC8F", "#3CB371",
    "#2E8B57", "#20B2AA", "#66CDAA", "#7FFFD4", "#AFEEEE", "#E0FFFF", "#FFFF00", "#FFD700", "#F0E68C", "#EEE8AA", "#BDB76B", "#DAA520", "#FFA500",
    "#FF8C00", "#FF7F50", "#FF6347", "#FF4500", "#FFDAB9", "#FFEFD5", "#FFFACD", "#FAFAD2", "#FFBF00", "#FFA500", "#FFC200", "#FFD700", "#FDB813",
    "#F5DEB3", "#E6BE8A", "#DAA520", "#C19A6B", "#C9B037", "#C7A500", "#C68E17", "#BF9000", "#B5A642", "#B2BEB5", "#FFA500", "#FF8C00", "#FF7F50",
    "#FF6347", "#FF4500", "#FFDAB9", "#FFEFD5", "#FFFACD", "#FAFAD2", "#F0E68C", "#EEE8AA", "#BDB76B", "#DAA520", "#C19A6B", "#C9B037", "#FF4500",
    "#FF6347", "#FF7F50", "#FF8C00", "#FFA07A", "#FFA500", "#FFB6C1", "#FFC0CB", "#FFDAB9", "#FFDEAD", "#FFE4B5", "#FFE4C4", "#FFE4E1", "#FFEBCD",
    "#FFEFD5", "#A52A2A", "#8B4513", "#CD853F", "#D2691E", "#F4A460", "#DEB887", "#D2B48C", "#BC8F8F", "#F5DEB3", "#F0E68C", "#EEE8AA", "#DAA520",
    "#BDB76B", "#8B8B00", "#556B2F", "#6699CC", "#5F9EA0", "#4F758B", "#2F4F4F", "#2A3F54", "#1C1C1C", "#3A4B5C", "#5C6D7E", "#7B8D9C", "#98AFC7",
    "#AEB6BF", "#B0C4DE", "#BFC1C2", "#CFD8DC", "#ECEFF1", "#808080", "#A9A9A9", "#C0C0C0", "#D3D3D3", "#DCDCDC", "#E8E8E8", "#F5F5F5", "#FAFAFA",
    "#F8F8FF", "#F0F8FF", "#E6E6FA", "#000000", "#0C0C0C", "#1C1C1C", "#2C2C2C", "#3C3C3C", "#4C4C4C", "#5C5C5C", "#6C6C6C", "#7C7C7C", "#8C8C8C",
    "#9C9C9C", "#ACACAC", "#BCBCBC", "#CCCCCC", "#DCDCDC"
]

export const customColors = [
    { hex: '#FF0000', rgb: 'rgb(255, 0, 0)', hsl: 'hsl(0, 100%, 50%)' },
    { hex: '#FFC0CB', rgb: 'rgb(255, 192, 203)', hsl: 'hsl(350, 100%, 88%)' },
    { hex: '#DC143C', rgb: 'rgb(220, 20, 60)', hsl: 'hsl(348, 83%, 47%)' },
    { hex: '#8B0000', rgb: 'rgb(139, 0, 0)', hsl: 'hsl(0, 100%, 27%)' },
    { hex: '#FF6347', rgb: 'rgb(255, 99, 71)', hsl: 'hsl(16, 100%, 67%)' },
    { hex: '#FF4500', rgb: 'rgb(255, 69, 0)', hsl: 'hsl(16, 100%, 50%)' },
    { hex: '#B22222', rgb: 'rgb(178, 34, 34)', hsl: 'hsl(0, 68%, 42%)' },
    { hex: '#CD5C5C', rgb: 'rgb(205, 92, 92)', hsl: 'hsl(0, 53%, 58%)' },
    { hex: '#7C0A02', rgb: 'rgb(124, 10, 2)', hsl: 'hsl(4, 98%, 25%)' },
    { hex: '#C21807', rgb: 'rgb(194, 24, 7)', hsl: 'hsl(4, 93%, 39%)' },
    { hex: '#E0115F', rgb: 'rgb(224, 17, 95)', hsl: 'hsl(336, 86%, 47%)' },
    { hex: '#800000', rgb: 'rgb(128, 0, 0)', hsl: 'hsl(0, 100%, 25%)' },
    { hex: '#B22222', rgb: 'rgb(178, 34, 34)', hsl: 'hsl(0, 68%, 42%)' },
    { hex: '#A45A52', rgb: 'rgb(164, 90, 82)', hsl: 'hsl(8, 31%, 51%)' },
    { hex: '#FFC0CB', rgb: 'rgb(255, 192, 203)', hsl: 'hsl(350, 100%, 88%)' },
    { hex: '#FF69B4', rgb: 'rgb(255, 105, 180)', hsl: 'hsl(330, 100%, 71%)' },
    { hex: '#FF1493', rgb: 'rgb(255, 20, 147)', hsl: 'hsl(328, 100%, 54%)' },
    { hex: '#C71585', rgb: 'rgb(199, 21, 133)', hsl: 'hsl(322, 81%, 43%)' },
    { hex: '#DB7093', rgb: 'rgb(219, 112, 147)', hsl: 'hsl(340, 60%, 65%)' },
    { hex: '#FFB6C1', rgb: 'rgb(255, 182, 193)', hsl: 'hsl(350, 100%, 86%)' },
    { hex: '#FFA07A', rgb: 'rgb(255, 160, 122)', hsl: 'hsl(30, 100%, 74%)' },
    { hex: '#FF7F50', rgb: 'rgb(255, 127, 80)', hsl: 'hsl(16, 100%, 66%)' },
    { hex: '#FF6347', rgb: 'rgb(255, 99, 71)', hsl: 'hsl(16, 100%, 67%)' },
    { hex: '#FF4500', rgb: 'rgb(255, 69, 0)', hsl: 'hsl(16, 100%, 50%)' },
    { hex: '#EE82EE', rgb: 'rgb(238, 130, 238)', hsl: 'hsl(300, 76%, 72%)' },
    { hex: '#DA70D6', rgb: 'rgb(218, 112, 214)', hsl: 'hsl(302, 59%, 65%)' },
    { hex: '#BA55D3', rgb: 'rgb(186, 85, 211)', hsl: 'hsl(288, 59%, 58%)' },
    { hex: '#9932CC', rgb: 'rgb(153, 50, 204)', hsl: 'hsl(280, 61%, 50%)' },
    { hex: '#4B0082', rgb: 'rgb(75, 0, 130)', hsl: 'hsl(275, 100%, 25%)' },
    { hex: '#7B68EE', rgb: 'rgb(123, 104, 238)', hsl: 'hsl(240, 80%, 67%)' },
    { hex: '#663399', rgb: 'rgb(102, 51, 153)', hsl: 'hsl(270, 50%, 40%)' },
    { hex: '#8B008B', rgb: 'rgb(139, 0, 139)', hsl: 'hsl(300, 100%, 27%)' },
    { hex: '#9400D3', rgb: 'rgb(148, 0, 211)', hsl: 'hsl(282, 100%, 41%)' },
    { hex: '#9932CC', rgb: 'rgb(153, 50, 204)', hsl: 'hsl(280, 61%, 50%)' },
    { hex: '#A020F0', rgb: 'rgb(160, 32, 240)', hsl: 'hsl(270, 87%, 52%)' },
    { hex: '#D8BFD8', rgb: 'rgb(216, 191, 216)', hsl: 'hsl(300, 24%, 80%)' },
    { hex: '#800080', rgb: 'rgb(128, 0, 128)', hsl: 'hsl(300, 100%, 25%)' },
    { hex: '#BA55D3', rgb: 'rgb(186, 85, 211)', hsl: 'hsl(288, 59%, 58%)' },
    { hex: '#9370DB', rgb: 'rgb(147, 112, 219)', hsl: 'hsl(260, 53%, 65%)' },
    { hex: '#8A2BE2', rgb: 'rgb(138, 43, 226)', hsl: 'hsl(271, 76%, 53%)' },
    { hex: '#6A5ACD', rgb: 'rgb(106, 90, 205)', hsl: 'hsl(240, 53%, 58%)' },
    { hex: '#483D8B', rgb: 'rgb(72, 61, 139)', hsl: 'hsl(248, 39%, 39%)' },
    { hex: '#4B0082', rgb: 'rgb(75, 0, 130)', hsl: 'hsl(275, 100%, 25%)' },
    { hex: '#483D8B', rgb: 'rgb(72, 61, 139)', hsl: 'hsl(248, 39%, 39%)' },
    { hex: '#3D2B1F', rgb: 'rgb(61, 43, 31)', hsl: 'hsl(27, 33%, 18%)' },
    { hex: '#3E2F5B', rgb: 'rgb(62, 47, 91)', hsl: 'hsl(261, 31%, 28%)' },
    { hex: '#4C516D', rgb: 'rgb(76, 81, 109)', hsl: 'hsl(232, 18%, 38%)' },
    { hex: '#5D3FD3', rgb: 'rgb(93, 63, 211)', hsl: 'hsl(248, 60%, 55%)' },
    { hex: '#5E5A80', rgb: 'rgb(94, 90, 128)', hsl: 'hsl(240, 17%, 42%)' },
    { hex: '#6574CD', rgb: 'rgb(101, 116, 205)', hsl: 'hsl(227, 53%, 61%)' },
    { hex: '#6A5ACD', rgb: 'rgb(106, 90, 205)', hsl: 'hsl(240, 53%, 58%)' },
    { hex: '#6B6B83', rgb: 'rgb(107, 107, 131)', hsl: 'hsl(240, 10%, 47%)' },
    { hex: '#6F00FF', rgb: 'rgb(111, 0, 255)', hsl: 'hsl(260, 100%, 50%)' },
    { hex: '#7B68EE', rgb: 'rgb(123, 104, 238)', hsl: 'hsl(240, 80%, 67%)' },
    { hex: '#7D26CD', rgb: 'rgb(125, 38, 205)', hsl: 'hsl(260, 70%, 49%)' },
    { hex: '#8A2BE2', rgb: 'rgb(138, 43, 226)', hsl: 'hsl(271, 76%, 53%)' },
    { hex: '#9400D3', rgb: 'rgb(148, 0, 211)', hsl: 'hsl(282, 100%, 41%)' },
    { hex: '#0000FF', rgb: 'rgb(0, 0, 255)', hsl: 'hsl(240, 100%, 50%)' },
    { hex: '#ADD8E6', rgb: 'rgb(173, 216, 230)', hsl: 'hsl(195, 53%, 79%)' },
    { hex: '#87CEFA', rgb: 'rgb(135, 206, 250)', hsl: 'hsl(203, 92%, 71%)' },
    { hex: '#1E90FF', rgb: 'rgb(30, 144, 255)', hsl: 'hsl(210, 100%, 56%)' },
    { hex: '#6495ED', rgb: 'rgb(100, 149, 237)', hsl: 'hsl(219, 79%, 65%)' },
    { hex: '#4169E1', rgb: 'rgb(65, 105, 225)', hsl: 'hsl(225, 73%, 57%)' },
    { hex: '#00008B', rgb: 'rgb(0, 0, 139)', hsl: 'hsl(240, 100%, 27%)' },
    { hex: '#0000CD', rgb: 'rgb(0, 0, 205)', hsl: 'hsl(240, 100%, 40%)' },
    { hex: '#191970', rgb: 'rgb(25, 25, 112)', hsl: 'hsl(240, 64%, 27%)' },
    { hex: '#00BFFF', rgb: 'rgb(0, 191, 255)', hsl: 'hsl(195, 100%, 50%)' },
    { hex: '#00CED1', rgb: 'rgb(0, 206, 209)', hsl: 'hsl(181, 100%, 41%)' },
    { hex: '#48D1CC', rgb: 'rgb(72, 209, 204)', hsl: 'hsl(179, 60%, 55%)' },
    { hex: '#AFEEEE', rgb: 'rgb(175, 238, 238)', hsl: 'hsl(180, 65%, 81%)' },
    { hex: '#87CEEB', rgb: 'rgb(135, 206, 235)', hsl: 'hsl(197, 72%, 73%)' },
    { hex: '#4682B4', rgb: 'rgb(70, 130, 180)', hsl: 'hsl(207, 44%, 49%)' },
    { hex: '#ADD8E6', rgb: 'rgb(173, 216, 230)', hsl: 'hsl(195, 53%, 79%)' },
    { hex: '#87CEFA', rgb: 'rgb(135, 206, 250)', hsl: 'hsl(203, 92%, 71%)' },
    { hex: '#1E90FF', rgb: 'rgb(30, 144, 255)', hsl: 'hsl(210, 100%, 56%)' },
    { hex: '#6495ED', rgb: 'rgb(100, 149, 237)', hsl: 'hsl(219, 79%, 65%)' },
    { hex: '#B0C4DE', rgb: 'rgb(176, 196, 222)', hsl: 'hsl(214, 41%, 78%)' },
    { hex: '#CAE1FF', rgb: 'rgb(202, 225, 255)', hsl: 'hsl(216, 100%, 85%)' },
    { hex: '#F0F8FF', rgb: 'rgb(240, 248, 255)', hsl: 'hsl(210, 100%, 97%)' },
    { hex: '#F0FFFF', rgb: 'rgb(240, 255, 255)', hsl: 'hsl(180, 100%, 97%)' },
    { hex: '#E6E6FA', rgb: 'rgb(230, 230, 250)', hsl: 'hsl(240, 67%, 94%)' },
    { hex: '#D3D3D3', rgb: 'rgb(211, 211, 211)', hsl: 'hsl(0, 0%, 83%)' },
    { hex: '#778899', rgb: 'rgb(119, 136, 153)', hsl: 'hsl(210, 14%, 53%)' },
    { hex: '#708090', rgb: 'rgb(112, 128, 144)', hsl: 'hsl(210, 13%, 50%)' },
    { hex: '#C6E2FF', rgb: 'rgb(198, 226, 255)', hsl: 'hsl(210, 100%, 86%)' },
    { hex: '#BFEFFF', rgb: 'rgb(191, 239, 255)', hsl: 'hsl(195, 100%, 86%)' },
    { hex: '#A4D3EE', rgb: 'rgb(164, 211, 238)', hsl: 'hsl(204, 67%, 77%)' },
    { hex: '#00FFFF', rgb: 'rgb(0, 255, 255)', hsl: 'hsl(180, 100%, 50%)' },
    { hex: '#E0FFFF', rgb: 'rgb(224, 255, 255)', hsl: 'hsl(180, 100%, 94%)' },
    { hex: '#AFEEEE', rgb: 'rgb(175, 238, 238)', hsl: 'hsl(180, 65%, 81%)' },
    { hex: '#7FFFD4', rgb: 'rgb(127, 255, 212)', hsl: 'hsl(160, 100%, 75%)' },
    { hex: '#40E0D0', rgb: 'rgb(64, 224, 208)', hsl: 'hsl(174, 72%, 56%)' },
    { hex: '#48D1CC', rgb: 'rgb(72, 209, 204)', hsl: 'hsl(178, 60%, 56%)' },
    { hex: '#00CED1', rgb: 'rgb(0, 206, 209)', hsl: 'hsl(181, 100%, 41%)' },
    { hex: '#20B2AA', rgb: 'rgb(32, 178, 170)', hsl: 'hsl(176, 70%, 41%)' },
    { hex: '#5F9EA0', rgb: 'rgb(95, 158, 160)', hsl: 'hsl(181, 25%, 50%)' },
    { hex: '#008B8B', rgb: 'rgb(0, 139, 139)', hsl: 'hsl(180, 100%, 27%)' },
    { hex: '#008080', rgb: 'rgb(0, 128, 128)', hsl: 'hsl(180, 100%, 25%)' },
    { hex: '#00FFFF', rgb: 'rgb(0, 255, 255)', hsl: 'hsl(180, 100%, 50%)' },
    { hex: '#00C5CD', rgb: 'rgb(0, 197, 205)', hsl: 'hsl(185, 100%, 40%)' },
    { hex: '#00BFFF', rgb: 'rgb(0, 191, 255)', hsl: 'hsl(195, 100%, 50%)' },
    { hex: '#1E90FF', rgb: 'rgb(30, 144, 255)', hsl: 'hsl(210, 100%, 56%)' },
    { hex: '#008080', rgb: 'rgb(0, 128, 128)', hsl: 'hsl(180, 100%, 25%)' },
    { hex: '#008B8B', rgb: 'rgb(0, 139, 139)', hsl: 'hsl(180, 100%, 27%)' },
    { hex: '#00CED1', rgb: 'rgb(0, 206, 209)', hsl: 'hsl(181, 100%, 41%)' },
    { hex: '#00FFFF', rgb: 'rgb(0, 255, 255)', hsl: 'hsl(180, 100%, 50%)' },
    { hex: '#00C5CD', rgb: 'rgb(0, 197, 205)', hsl: 'hsl(185, 100%, 40%)' },
    { hex: '#00E5EE', rgb: 'rgb(0, 229, 238)', hsl: 'hsl(186, 100%, 47%)' },
    { hex: '#00F5FF', rgb: 'rgb(0, 245, 255)', hsl: 'hsl(187, 100%, 50%)' },
    { hex: '#40E0D0', rgb: 'rgb(64, 224, 208)', hsl: 'hsl(174, 72%, 56%)' },
    { hex: '#48D1CC', rgb: 'rgb(72, 209, 204)', hsl: 'hsl(178, 60%, 56%)' },
    { hex: '#7FFFD4', rgb: 'rgb(127, 255, 212)', hsl: 'hsl(160, 100%, 75%)' },
    { hex: '#AFEEEE', rgb: 'rgb(175, 238, 238)', hsl: 'hsl(180, 65%, 81%)' },
    { hex: '#BBFFFF', rgb: 'rgb(187, 255, 255)', hsl: 'hsl(180, 100%, 86%)' },
    { hex: '#E0FFFF', rgb: 'rgb(224, 255, 255)', hsl: 'hsl(180, 100%, 94%)' },
    { hex: '#E6FFFF', rgb: 'rgb(230, 255, 255)', hsl: 'hsl(180, 100%, 97%)' },
    { hex: '#F0FFFF', rgb: 'rgb(240, 255, 255)', hsl: 'hsl(180, 100%, 97%)' }
];


export const red_color_shades = [
    "#FF0000",
    "#FFC0CB",
    "#DC143C",
    "#8B0000",
    "#FF6347",
    "#FF4500",
    "#B22222",
    "#CD5C5C",
    "#7C0A02",
    "#C21807",
    "#E0115F",
    "#800000",
    "#B22222",
    "#A45A52",
    "#800080",
    "#BA55D3",
    "#9370DB",
    "#8A2BE2",
    "#6A5ACD",
    "#483D8B",
    "#4B0082",
    "#7B68EE",
    "#663399",
    "#8B008B",
    "#9400D3",
    "#9932CC",
    "#A020F0",
    "#D8BFD8"
]

export const pink_color_shades = [
    "#FFC0CB",
    "#FF69B4",
    "#FF1493",
    "#C71585",
    "#DB7093",
    "#FFB6C1",
    "#FFA07A",
    "#FF7F50",
    "#FF6347",
    "#FF4500",
    "#EE82EE",
    "#DA70D6",
    "#BA55D3",
    "#9932CC"
]

export const pirple_color_shades = [
    "#800080",
    "#BA55D3",
    "#9370DB",
    "#8A2BE2",
    "#6A5ACD",
    "#483D8B",
    "#4B0082",
    "#7B68EE",
    "#663399",
    "#8B008B",
    "#9400D3",
    "#9932CC",
    "#A020F0",
    "#D8BFD8"
]

export const Deeppirple_color_shades = [
    "#4B0082",
    "#7B68EE",
    "#663399",
    "#8B008B",
    "#9400D3",
    "#9932CC",
    "#A020F0",
    "#D8BFD8",
    "#800080",
    "#BA55D3",
    "#9370DB",
    "#8A2BE2",
    "#6A5ACD",
    "#483D8B"
]

export const indigo_color_shades = [
    "#4B0082",
    "#483D8B",
    "#3D2B1F",
    "#3E2F5B",
    "#4C516D",
    "#5D3FD3",
    "#5E5A80",
    "#6574CD",
    "#6A5ACD",
    "#6B6B83",
    "#6F00FF",
    "#7B68EE",
    "#7D26CD",
    "#8A2BE2",
    "#9400D3"
]

export const blue_color_shades = [
    "#0000FF",
    "#ADD8E6",
    "#87CEFA",
    "#1E90FF",
    "#6495ED",
    "#4169E1",
    "#00008B",
    "#0000CD",
    "#191970",
    "#00BFFF",
    "#00CED1",
    "#48D1CC",
    "#AFEEEE",
    "#87CEEB",
    "#4682B4"
]

export const light_blue_color_shades = [
    "#ADD8E6",
    "#87CEFA",
    "#1E90FF",
    "#6495ED",
    "#B0C4DE",
    "#CAE1FF",
    "#F0F8FF",
    "#F0FFFF",
    "#E6E6FA",
    "#D3D3D3",
    "#778899",
    "#708090",
    "#C6E2FF",
    "#BFEFFF",
    "#A4D3EE"
]

export const cyan_color_shades = [
    "#00FFFF",
    "#E0FFFF",
    "#AFEEEE",
    "#7FFFD4",
    "#40E0D0",
    "#48D1CC",
    "#00CED1",
    "#20B2AA",
    "#5F9EA0",
    "#008B8B",
    "#008080",
    "#00FFFF",
    "#00C5CD",
    "#00BFFF",
    "#1E90FF"
]

export const teal_color_shades = [
    "#008080",
    "#008B8B",
    "#00CED1",
    "#00FFFF",
    "#00C5CD",
    "#00E5EE",
    "#00F5FF",
    "#40E0D0",
    "#48D1CC",
    "#7FFFD4",
    "#AFEEEE",
    "#BBFFFF",
    "#E0FFFF",
    "#E6FFFF",
    "#F0FFFF"
]

export const green_color_shades = [
    "#008000",
    "#00FF00",
    "#7FFF00",
    "#ADFF2F",
    "#9ACD32",
    "#32CD32",
    "#228B22",
    "#006400",
    "#556B2F",
    "#8FBC8F",
    "#2E8B57",
    "#3CB371",
    "#20B2AA",
    "#66CDAA",
    "#7FFFD4"
]

export const lightGreen_color_shades = [
    "#00FF00",
    "#7CFC00",
    "#7FFF00",
    "#ADFF2F",
    "#32CD32",
    "#00FA9A",
    "#00FF7F",
    "#90EE90",
    "#98FB98",
    "#9ACD32",
    "#8FBC8F",
    "#3CB371",
    "#2E8B57",
    "#20B2AA",
    "#66CDAA"
]

export const lime_color_shades = [
    "#00FF00",
    "#32CD32",
    "#7FFF00",
    "#ADFF2F",
    "#00FA9A",
    "#98FB98",
    "#90EE90",
    "#8FBC8F",
    "#3CB371",
    "#2E8B57",
    "#20B2AA",
    "#66CDAA",
    "#7FFFD4",
    "#AFEEEE",
    "#E0FFFF"
]

export const yellow_color_shades = [
    "#FFFF00",
    "#FFD700",
    "#F0E68C",
    "#EEE8AA",
    "#BDB76B",
    "#DAA520",
    "#FFA500",
    "#FF8C00",
    "#FF7F50",
    "#FF6347",
    "#FF4500",
    "#FFDAB9",
    "#FFEFD5",
    "#FFFACD",
    "#FAFAD2"
]

export const amber_color_shades = [
    "#FFBF00",
    "#FFA500",
    "#FFC200",
    "#FFD700",
    "#FDB813",
    "#F5DEB3",
    "#E6BE8A",
    "#DAA520",
    "#C19A6B",
    "#C9B037",
    "#C7A500",
    "#C68E17",
    "#BF9000",
    "#B5A642",
    "#B2BEB5"
]

export const orange_color_shades = [
    "#FFA500",
    "#FF8C00",
    "#FF7F50",
    "#FF6347",
    "#FF4500",
    "#FFDAB9",
    "#FFEFD5",
    "#FFFACD",
    "#FAFAD2",
    "#F0E68C",
    "#EEE8AA",
    "#BDB76B",
    "#DAA520",
    "#C19A6B",
    "#C9B037"
]

export const deep_orange_color_shades = [
    "#FF4500",
    "#FF6347",
    "#FF7F50",
    "#FF8C00",
    "#FFA07A",
    "#FFA500",
    "#FFB6C1",
    "#FFC0CB",
    "#FFDAB9",
    "#FFDEAD",
    "#FFE4B5",
    "#FFE4C4",
    "#FFE4E1",
    "#FFEBCD",
    "#FFEFD5"
]

export const brown_color_shades = [
    "#A52A2A",
    "#8B4513",
    "#CD853F",
    "#D2691E",
    "#F4A460",
    "#DEB887",
    "#D2B48C",
    "#BC8F8F",
    "#F5DEB3",
    "#F0E68C",
    "#EEE8AA",
    "#DAA520",
    "#BDB76B",
    "#8B8B00",
    "#556B2F"
]

export const blue_grey_color_shades = [
    "#6699CC",
    "#5F9EA0",
    "#4F758B",
    "#2F4F4F",
    "#2A3F54",
    "#1C1C1C",
    "#3A4B5C",
    "#5C6D7E",
    "#7B8D9C",
    "#98AFC7",
    "#AEB6BF",
    "#B0C4DE",
    "#BFC1C2",
    "#CFD8DC",
    "#ECEFF1"
]

export const grey_color_shades = [
    "#808080",
    "#A9A9A9",
    "#C0C0C0",
    "#D3D3D3",
    "#DCDCDC",
    "#E8E8E8",
    "#F5F5F5",
    "#FAFAFA",
    "#F8F8FF",
    "#F0F8FF",
    "#E6E6FA"
]

export const black_color_shades = [
    "#000000",
    "#0C0C0C",
    "#1C1C1C",
    "#2C2C2C",
    "#3C3C3C",
    "#4C4C4C",
    "#5C5C5C",
    "#6C6C6C",
    "#7C7C7C",
    "#8C8C8C",
    "#9C9C9C",
    "#ACACAC",
    "#BCBCBC",
    "#CCCCCC",
    "#DCDCDC"
]

